// Here you define the default values for local apollo state (@client only values)
// https://www.apollographql.com/docs/react/local-state/local-state-management/

export const defaults = {};

export const defaultApolloCache = {
  ROOT_QUERY: {
    insuranceDataExchange: {
      __typename: 'insuranceDataExchange',
      documentsSteps: []
    },
    policyRenewalItems: {
      __typeName: 'policyRenewalItems',
      data: []
    },
    crossCheckResultStatus: {
      __typeName: 'crossCheckResultStatus',
      data: []
    },
    insuranceEventsCorrelation: {
      __typename: 'insuranceEventsCorrelation',
      correlations: []
    },
    policyGenerationThistle: {
      __typename: 'policyGenerationThistle',
      elements: []
    },
    serverErrorHandlingEventKeys: {
      __typename: 'serverErrorHandlingEventKeys',
      keys: []
    },
    networkStatus: {
      __typename: 'networkStatus',
      isConnected: false
    },
    oidcUser: {
      __typename: 'oidcUser',
      token: null
    },
    __typename: 'Query'
  }
};
